import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ManageMerchantFormContainer from "../../components/Merchant/ManageMerchantFormContainer";
import ManageMerchantHeader from "../../components/Merchant/ManageMerchantHeader";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { ToastMessage } from "../../components/ToastMessage";
import {
  getFormatedMerchantResponse,
  getFormattedOutlets,
  getFormattedRoles,
} from "../../helper";
import {
  addMerchant,
  fetchMerchantDetails,
  updateMerchant,
} from "../../services/merchantService";
import { getOutlet } from "../../services/outletService";
import { getSettings } from "../../services/settingsService";
import { validateAddMerchant } from "./validateAddMerchant";

const AddMerchant = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    message: "",
    variant: "",
  });
  const [outlets, setOutlets] = useState([]);
  const [roles, setRoles] = useState([]);
  const [data, setData] = useState({
    outlet: "",
    password: "",
    role: [],
    email: "",
    status: "",
    name: "",
  });
  const [error, setError] = useState({
    outlet: "",
    password: "",
    role: "",
    email: "",
    status: "",
    name: "",
  });

  useEffect(() => {
    fetchOutletList();
    fetchRoles();
    if (id) {
      fetchMerchant();
    }
  }, []); // eslint-disable-line

  const fetchOutletList = async () => {
    try {
      let { data } = await getOutlet();
      if (data.code === 200) {
        let formattedOutlets = getFormattedOutlets(data?.data, "Select Outlet");
        setOutlets(formattedOutlets);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRoles = async () => {
    try {
      let { data } = await getSettings("cms");

      if (data.code === 200) {
        let formattedRoles = getFormattedRoles(data?.data?.access_rights);
        setRoles(formattedRoles);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMerchant = async () => {
    try {
      let { data } = await fetchMerchantDetails(id);
      if (data.code === 200) {
        let formattedData = getFormatedMerchantResponse(data?.data);
        setData(formattedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    let formData = { ...data };
    let formError = { ...error };
    //@ts-ignore
    formData[event.target.name] = event.target.value;
    //@ts-ignore
    formError[event.target.name] = "";
    setData(formData);
    setError(formError);
  };

  const handleSubmit = () => {
    if (!validateAddMerchant(data, setError)) {
      setError({
        outlet: "",
        password: "",
        role: "",
        email: "",
        status: "",
        name: "",
      });
      if (id) {
        editMerchantFlow();
      } else {
        addMerchantFlow();
      }
    }
  };

  const addMerchantFlow = async () => {
    let postableData = { ...data };
    //@ts-ignore
    postableData.outlet = postableData.outlet ? postableData.outlet : null;

    try {
      let response = await addMerchant(postableData);
      //@ts-ignore
      if (response.status === 201) {
        setFeedbackModal({
          open: true,
          message: "Merchant added successfully",
          variant: "success",
        });
      }
    } catch (err: { message: string } | any) {
      if (navigator.onLine) {
        setFeedbackModal({
          open: true,
          message: err?.message,
          variant: "error",
        });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
  };

  const editMerchantFlow = async () => {
    let postableData = { ...data };
    //@ts-ignore
    delete postableData["password"];
    //@ts-ignore
    postableData.status = postableData.status === "1" ? true : false;
    //@ts-ignore
    postableData.outlet = postableData.outlet ? postableData.outlet : null;
    try {
      let response = await updateMerchant(postableData, id);
      //@ts-ignore
      if (response.status === 200) {
        setFeedbackModal({
          open: true,
          message: "Merchant updated successfully",
          variant: "success",
        });
      }
    } catch (err: { message: string } | any) {
      if (navigator.onLine) {
        setFeedbackModal({
          open: true,
          message: err?.message,
          variant: "error",
        });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmitModal = () => {
    setFeedbackModal({
      open: false,
      message: "",
      variant: "",
    });
    if (feedbackModal.variant === "success") {
      navigate("/admin/merchant");
    }
  };

  const handleRoleChange = (id: string) => {
    let formData = { ...data };
    let formError = { ...error };

    formError["role"] = "";
    let selectedRoles: string[] = data.role;

    if (!selectedRoles.includes(id)) {
      selectedRoles.push(id);
    } else {
      selectedRoles.splice(selectedRoles.indexOf(id), 1);
    }

    console.log(selectedRoles);
    

    if (!selectedRoles.includes("3")) {
      formData["outlet"] = "";
      formError["outlet"] = "";
    }

    //@ts-ignore
    if (selectedRoles.includes(5)) {
      selectedRoles = [id];
    }

    //@ts-ignore
    if (selectedRoles.includes(8)) {
      selectedRoles = [id];
    }

    // @ts-ignore
    setData({ ...formData, role: selectedRoles });
    setError(formError);
  };

  const getFilteredOutlet = (outlet: any, role: any) => {
    if (role[0] === 8) {
      return outlet;
    } else if (role[0] === 5) {
      return outlet.filter(
        (item: any) => item.type === "parks" || item.value === ""
      );
    } else {
      return outlet.filter((item: any) => item.type !== "parks");
    }
  };

  return (
    <div>
      <ManageMerchantHeader />
      <ManageMerchantFormContainer
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        onChange={handleChange}
        error={error}
        value={data}
        roles={roles}
        outlets={getFilteredOutlet(outlets, data.role)}
        isEditFlow={!!id}
        onRoleSelect={handleRoleChange}
      />
      {feedbackModal.open && (
        <ErrorSuccessModal
          //@ts-ignore
          variant={feedbackModal.variant}
          heading={feedbackModal.message}
          buttonLabel="Ok"
          onSubmit={handleSubmitModal}
        />
      )}
    </div>
  );
};

export default AddMerchant;
